/** What every meter question is keyed and answered by (ADR-0099, ADR-0103).
 *
 * Kept out of `MeterPicker.tsx` because that file exports components, and a module that exports
 * both defeats fast refresh for the screens that import it.
 */

/** A group is a site, a kind of activity and a fuel - what the importer classifies a row by.
 *
 * The one spelling, shared by the document import and the spreadsheet round trip, and the string the
 * server puts on a row (`DiffRowOut.meter_group`) so a screen can tell which questions the rows a
 * person selected actually ask. Built from the three fields the server groups by and never from a
 * row's `meter` text (SEC-05). */
export function meterGroupKey(group: {
  facility_id: string;
  category: string;
  fuel_or_carrier: string;
}): string {
  return `${group.facility_id}|${group.category}|${group.fuel_or_carrier}`;
}

/** The value of the explicit "none of these" option - a statement, where `""` is no answer yet. */
export const NONE_OF_THESE = "none";
